import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import PrivateEventIcon from "../../assets/public_off-24px.svg";
import { useStyles } from "./styles";

interface Props {
  inviteeEmail?: string;
}

export const PrivateEventNudge = ({ inviteeEmail }: Props) => {
  const { t } = useI18n(["eventLanding"]);
  const styles = useStyles();

  return (
    <div className={styles.privateMessageContainer}>
      <div className={styles.privateMessageTitle}>
        <img
          className={styles.privateMessageIcon}
          src={PrivateEventIcon}
          alt=""
        />
        <Typography variant="h4" className={styles.privateEventText}>
          {t("eventLanding:private.event")}
        </Typography>
      </div>
      <Typography variant="body1" className={styles.privateMessageContent}>
        {inviteeEmail
          ? t("eventLanding:strict.invited.guests.access.email", {
              email: inviteeEmail,
            })
          : t("eventLanding:strict.invited.guests.access")}
      </Typography>
    </div>
  );
};
